import { mulTimeDimensionSinIndexMulValue } from '@/utils/reportResponseUtil';
import * as bhc from '../services/bhc';

export default {
  namespace: 'bhc',

  state: {
    totalSales: [],
    totalCustomer: [],
    BHC_TOTAL_SALES: [],
    BHC_TREND_ACTUAL: [],
    BHC_TREND_LAST_YEAR: [],
    BHC_TREND_FORECAST: [],
    BHC_NEW_CUSTOMER: [],
    BHC_EXISTING_CUSTOMER: [],
    BHC_TREND_TARGET_ACHIEVED: [],
    KpiBasketData: [],
    KpiContributionData: [],
    KpiCustomerData: [],
    KpiRecruitmentData: [],
    KpiRepeatData: [],
    KpiRetentionData: [],
    KpiSpendingData: [],
    KpiUptData: [],
    productList: [],
    date: {},
    allChannel: [],
    online: [],
    offline: [],
    BHC_TREND_ACTUALFIRST: [],
    actualDataFirst: [],
    BHC_TREND_ACTUALSECOND: [],
    actualDataSecond: [],
    yearFirst: null,
    yearSecond: null,
    channelList: [],

    totalSalesV2: [],
    totalCustomerV2: [],
  },

  effects: {
    // *getTotalSales({ payload: { values } }, { call, put }) {
    //   const response = yield call(bhc.getTotalSales, values);
    //   let data = [];
    //   const newSales = response.data.filter((item) => item.index === 'BHC_TOTAL_SALES');
    //   newSales.forEach((item) => {
    //     data.push({
    //       name: item.values[0].value,
    //       value: Number(item.values[1].value),
    //       groupId: item.values[0].value,
    //     });
    //   });
    //   yield put({
    //     type: 'save',
    //     payload: {
    //       totalSales: response.data,
    //       BHC_TOTAL_SALES: data,
    //     },
    //   });
    // },
    *getTotalSalesV2({ payload: { values } }, { call, put }) {
      const response = yield call(bhc.getTotalSalesV2, values);
      yield put({
        type: 'save',
        payload: {
          totalSalesV2: response.data,
        },
      });
    },
    // 查询渠道接口
    *getChannel({ payload: { values }, callback }, { call, put }) {
      const response = yield call(bhc.getChannel, values);
      response.data.sort((x, y) => {
        return x?.sort - y?.sort;
      });
      const channelList = [];
      response.data.forEach((item) => {
        channelList.push(item.parentName);
      });
      yield put({
        type: 'save',
        payload: {
          channelList: channelList,
        },
      });
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
    },
    // 查询子渠道
    *getSubChannel({ payload: { values }, callback }, { call, put }) {
      const response = yield call(bhc.getSubChannel, values);
      const allChannel = response.data.allChannel;
      const online = response.data.online;
      const appendId = (arr, layer, pid) => {
        for (let i = 0; i < arr.length; i++) {
          arr[i].id = String(pid) + '1' + i;
          arr[i].pid = pid;
          if (arr[i].children) {
            appendId(arr[i].children, layer + 1, String(pid) + '1' + i);
          }
        }
      };
      appendId(online, 0, 0);
      const offline = response.data.offline;
      appendId(offline, 0, 0);
      online.sort((x, y) => {
        return x?.sort - y?.sort;
      });
      offline.sort((x, y) => {
        return x?.sort - y?.sort;
      });
      yield put({
        type: 'save',
        payload: {
          channel: response.data,
          allChannel: allChannel,
          online: online,
          offline: offline,
        },
      });
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
    },
    *getTotalSalesReportV2({ payload: { values } }, { call, put }) {
      const response = yield call(bhc.getTotalSalesReportV2, values);
      const dataList = mulTimeDimensionSinIndexMulValue(response.data || []);

      const lyData = response.data.filter(
        (item) => item.index === 'LAST_YEAR_SALES',
      ); // 去年
      const tyData = response.data.filter(
        (item) => item.index === 'CURRENT_SALES',
      ); // 今年

      const LYData = [...new Set(lyData.map((item) => item.timeDimension))];
      const TYData = [...new Set(tyData.map((item) => item.timeDimension))];

      let BHC_TREND_ACTUALFIRST = LYData.map((item) => dataList[item])[0];
      let BHC_TREND_ACTUALSECOND = TYData.map((item) => dataList[item])[0];

      let actualDataFirst = [];
      let actualDataSecond = [];
      let yearData = [
        ...new Set(response.data.map((item) => item.timeDimension)),
      ];
      yearData = yearData.sort((a, b) => a - b);
      // let BHC_TREND_ACTUALFIRST = dataList[yearData?.[0]] || [];
      // let BHC_TREND_ACTUALSECOND = dataList[yearData?.[1]] || [];
      BHC_TREND_ACTUALFIRST.sort((x, y) => {
        return x.LABEL - y.LABEL;
      });
      BHC_TREND_ACTUALFIRST.forEach((i) => {
        actualDataFirst.push(i.VALUE);
      });

      BHC_TREND_ACTUALSECOND.sort((x, y) => {
        return x.LABEL - y.LABEL;
      });
      BHC_TREND_ACTUALSECOND.forEach((i) => {
        actualDataSecond.push(i.VALUE);
      });
      yield put({
        type: 'save',
        payload: {
          BHC_TREND_ACTUALFIRST: BHC_TREND_ACTUALFIRST,
          actualDataFirst: actualDataFirst,
          BHC_TREND_ACTUALSECOND: BHC_TREND_ACTUALSECOND,
          actualDataSecond: actualDataSecond,
          yearFirst: yearData?.[0],
          yearSecond: yearData?.[1],
        },
      });
    },
    *getTotalCustomer({ payload: { values } }, { call, put }) {
      const response = yield call(bhc.getTotalCustomer, values);
      let customerData = [];
      let customerNewData = [];
      const newSales = response.data.filter(
        (item) => item.index === 'BHC_TOTAL_CUSTOMER',
      );
      newSales.forEach((item) => {
        customerData.push({
          name: item.values[0].value,
          value: Number(item.values[1].value),
          groupId: item.values[0].value,
        });
      });
      const newCustomer = response.data.filter(
        (item) => item.index === 'BHC_NEW_CUSTOMER',
      );
      newCustomer.forEach((item) => {
        customerNewData.push({
          name: item.values[0].value,
          value: Number(item.values[1].value),
          groupId: item.values[0].value,
        });
      });
      let exitCustomerData = [];
      const exitCustomer = response.data.filter(
        (item) => item.index === 'BHC_EXISTING_CUSTOMER',
      );
      exitCustomer.forEach((item) => {
        exitCustomerData.push({
          name: item.values[0].value,
          value: Number(item.values[1].value),
          groupId: item.values[0].value,
        });
      });
      yield put({
        type: 'save',
        payload: {
          totalCustomer: response.data,
          BHC_TOTAL_CUSTOMER: customerData,
          BHC_NEW_CUSTOMER: customerNewData,
          BHC_EXISTING_CUSTOMER: exitCustomerData,
        },
      });
    },
    *getMemberReport({ payload: { values } }, { call, put }) {
      const response = yield call(bhc.getMemberReport, values);
      yield put({
        type: 'save',
        payload: {
          totalCustomerV2: response.data,
        },
      });
    },
    // kpi接口
    // 查询客单价趋势接口
    // 查询会员贡献趋势接口 getKpiContribution
    // 查询会员趋势接口 getKpiCustomer
    // 查询新招会员趋势接口 getKpiRecruitment
    // 查询复购趋势接口 getKpiRepeat
    // 查询留存趋势接口 getKpiRetention
    // 查询人均购买趋势接口 getKpiSpending
    // 查询客单件趋势接口 getKpiUpt
    *getKpiList({ payload: { values } }, { all, call, put }) {
      const [
        KpiBasket,
        KpiCustomer,
        KpiRecruitment,
        KpiRepeat,
        KpiRetention,
        KpiSpending,
        KpiUpt,
      ] = yield all([
        call(bhc.getKpiTrendReport, { ...values, trendType: 'unitPrice' }), // 客单价
        call(bhc.getKpiTrendReport, { ...values, trendType: 'memberCount' }), // 会员数
        call(bhc.getKpiTrendReport, { ...values, trendType: 'newMemberCount' }), // 新招募会员数
        call(bhc.getKpiTrendReport, { ...values, trendType: 'repurchaseRate' }), // 复购率
        call(bhc.getKpiTrendReport, { ...values, trendType: 'retentionRate' }), // 留存率
        call(bhc.getKpiTrendReport, {
          ...values,
          trendType: 'avgPurchaseAmount',
        }), // 会员人均购买金额
        call(bhc.getKpiTrendReport, {
          ...values,
          trendType: 'avgItemsPerOrder',
        }), // 客单件
      ]);
      const KpiContribution = { data: [] };
      const sortData = (data) => {
        const LYNewData = [];
        const LYNewSort = [];
        const LYExitData = [];
        const LYExitSort = [];
        const TYNewData = [];
        const TYNewSort = [];
        const TYExitData = [];
        const TYExitSort = [];
        const achData = data.filter((item) => item.index === 'LY');
        const tyData = data.filter((item) => item.index === 'TY');
        const newData = achData.filter((item) => item.timeDimension === 'NEW');
        newData.forEach((item) => {
          LYNewSort.push({
            name: item.values[0].value,
            value: Number(item.values[1].value),
            groupId: item.values[0].value,
          });
        });
        LYNewSort.sort((x, y) => {
          return x.name - y.name;
        });
        LYNewSort.forEach((item) => {
          LYNewData.push(Number(item.value));
        });
        const LYNewSortName = LYNewSort[0]?.name;
        const newTyData = tyData.filter((item) => item.timeDimension === 'NEW');
        newTyData.forEach((item) => {
          TYNewSort.push({
            name: item.values[0].value,
            value: Number(item.values[1].value),
            groupId: item.values[0].value,
          });
        });
        TYNewSort.sort((x, y) => {
          return x.name - y.name;
        });
        TYNewSort.forEach((item) => {
          TYNewData.push(Number(item.value));
        });
        const TYNewSortName = TYNewSort[0]?.name;
        const existTyData = tyData.filter(
          (item) => item.timeDimension === 'EXISTING',
        );
        existTyData.forEach((item) => {
          TYExitSort.push({
            name: item.values[0].value,
            value: Number(item.values[1].value),
            groupId: item.values[0].value,
          });
        });
        TYExitSort.sort((x, y) => {
          return x.name - y.name;
        });
        TYExitSort.forEach((item) => {
          TYExitData.push(Number(item.value));
        });
        const TYExitSortName = TYExitSort[0]?.name;
        const existData = achData.filter(
          (item) => item.timeDimension === 'EXISTING',
        );
        existData.forEach((item) => {
          LYExitSort.push({
            name: item.values[0].value,
            value: Number(item.values[1].value),
            groupId: item.values[0].value,
          });
        });
        LYExitSort.sort((x, y) => {
          return x.name - y.name;
        });
        LYExitSort.forEach((item) => {
          LYExitData.push(Number(item.value));
        });
        const LYExitSortName = LYExitSort[0]?.name;
        const datalist = [
          {
            LYNewData,
            LYNewSortName,
          },
          {
            LYExitData,
            LYExitSortName,
          },
          {
            TYNewData,
            TYNewSortName,
          },
          {
            TYExitData,
            TYExitSortName,
          },
        ];
        return datalist;
      };

      yield put({
        type: 'save',
        payload: {
          KpiBasketData: sortData(KpiBasket.data),
          KpiContributionData: sortData(KpiContribution.data),
          KpiCustomerData: sortData(KpiCustomer.data),
          KpiRecruitmentData: sortData(KpiRecruitment.data),
          KpiRepeatData: sortData(KpiRepeat.data),
          KpiRetentionData: sortData(KpiRetention.data),
          KpiSpendingData: sortData(KpiSpending.data),
          KpiUptData: sortData(KpiUpt.data),
        },
      });
    },
    // 查询主推产品接口
    *getHotProduct({ payload: { values } }, { call, put }) {
      const response = yield call(bhc.getHotProduct, values);
      const data = Array.isArray(response?.data) ? response.data : [];
      // 同一 index 的多条指标记录聚合为一个剧目，index 转成数字作为分组依据
      const productMap = new Map();
      data.forEach((item) => {
        const index = Number(item?.index);
        const itemData = productMap.get(index) || { index: index };
        // values[0] 为指标名，values[1] 为指标值
        const label = item?.values?.[0]?.value;
        const metricValue = item?.values?.[1]?.value;
        if (label) {
          itemData[label] = metricValue;
        }
        productMap.set(index, itemData);
      });
      // 按 index 升序排序展示
      const productList = [...productMap.values()].sort(
        (a, b) => a.index - b.index,
      );
      yield put({
        type: 'save',
        payload: {
          productList: productList,
        },
      });
    },
    // 查询时间接口
    *getTime({ payload: { values } }, { call, put }) {
      const response = yield call(bhc.getTime, values);
      yield put({
        type: 'save',
        payload: {
          date: response.data,
        },
      });
    },
  },

  reducers: {
    save(state, action) {
      return { ...state, ...action.payload };
    },
  },

  subscriptions: {},
};
